import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      gap: '40px',
      '@media (max-width: 768px)': {
        flexDirection: 'column'
      }
    },
    image: {
      width: '200px'
    },
    name: {
      color: palette.title.primary,
      margin: 0,
      fontSize: '36px',
      fontWeight: 700,
      marginBottom: '5px'
    },
    carousel: {
      width: '100%',
      maxWidth: '250px',
      marginTop: '5px',
      marginBottom: '10px'
    },
    infos: {
      margin: 0,
      fontWeight: 400,
      marginBottom: '10px'
    },
    actions: {
      display: 'flex',
      gap: '20px',
      alignItems: 'center'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
